import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceBase } from '../shared/servicebase'
import { Helper } from '../shared/Helper';


@Injectable({
  providedIn: 'root'
})
export class IntegracaoService extends ServiceBase {

  constructor(http: HttpClient) {
    super(http);

  }

  public cachePlanilha: any;

  public UploadPlanilha(arquivo) {    
    var codTab = Helper.getCodTab();    
    return this.UploadFile('integracao/uploadplanilha/' + Helper.getUserIdToken() + '/' + codTab, arquivo);
  }

  

   GetCachePlanilha(){        
    return this.GetValue<any>('integracao/getcacheplanilha/' + Helper.getUserIdToken());
  }
}
